export const CLIENT_EVENTS = [];
export const CustomIds = {
  AliasId: 'aliasId'
};
export let StatsigEnvironment = function (StatsigEnvironment) {
  StatsigEnvironment["Development"] = "development";
  StatsigEnvironment["Staging"] = "staging";
  StatsigEnvironment["Production"] = "production";
  return StatsigEnvironment;
}({});